window.REBASE = window.REBASE || {};
REBASE.theme = {};

var Shopify = Shopify || {};

/*
  * Use session storage to store current and previous page position
  */
const saveScrollPosition = function() {
  const currentUrl = window.location.href.split('?')[0];
  const storedUrl = sessionStorage.getItem("ghCurrentUrl");
  const storedScrollPos = sessionStorage.getItem("ghCurrentScrollPos");

  if (storedUrl &&  storedUrl != currentUrl) {
    sessionStorage.setItem("ghPreviousUrl", storedUrl);
    sessionStorage.setItem("ghPreviousScrollPos", storedScrollPos);
  }
  sessionStorage.setItem("ghCurrentUrl", currentUrl);
  sessionStorage.setItem("ghCurrentScrollPos", window.scrollY);
};

/*
  * If page was previously visited or current page was reloaded
  * scroll to saved scroll position
  */
const scrolltoPosition = function() {
  const storedUrl = sessionStorage.getItem("ghCurrentUrl");
  const storedScrollPos = sessionStorage.getItem("ghCurrentScrollPos");
  const storedPreviousUrl = sessionStorage.getItem("ghPreviousUrl");
  const storedPreviousScrollPos = sessionStorage.getItem("ghPreviousScrollPos");

  if ((storedUrl != window.location.href) && (storedPreviousUrl != window.location.href)) {return;}

  const scrollToPos = storedPreviousUrl == window.location.href ? storedPreviousScrollPos : storedScrollPos;

  window.scrollTo({top: scrollToPos, behavior: 'smooth'});
};


// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// Focus handling
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (elementToFocus) elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

// ScrollLock
class ScrollLock {
  constructor() {
    this.mobileScrollPosition = 0;
  }

  enableBodyScrollLock(bodyPos = null) {
    const body = document.querySelector('body');
    this.mobileScrollPosition = window.pageYOffset;
    let pos = this.mobileScrollPosition;
    if(bodyPos) pos = bodyPos;
    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = `-${pos}px`;
    body.style.width = '100%';
  }

  disableBodyScrollLock() {
    const body = document.querySelector('body');
    body.style.removeProperty('overflow');
    body.style.removeProperty('position');
    body.style.removeProperty('top');
    body.style.removeProperty('width');
    body.style.removeProperty('top');
    window.scrollTo({top: this.mobileScrollPosition, left: 0, behavior: 'instant' });
  }
}
// expose the scroll locker to the codebase
var scrollLock = new ScrollLock();

// Slide out drawer
class SlideOutDrawer extends HTMLElement {
  constructor() {
    super();
    this.container = null;
    this.backdrop = null;
    this.closeButton = null;
    this.isOpen = false;
    this.identifier = '';
    this.fullIdentifier = '';
    this.isInitialized = false;
    this.escapeListener = null;
    this.focusedElementBeforeOpen = null;
    this.animationDuration = 300;
    this.scrollPosition = 0;
  }

  connectedCallback() {
    if (this.isInitialized) return;
    this.isInitialized = true;
    this.initializeDrawer();
  }

  initializeDrawer() {
    this.setElements();
    if (!this.hasElements()) return;
    this.setVariables();
    this.setEventListeners();
  }

  setElements() {
    this.container = this.querySelector('.slide-out-drawer__container');
    this.backdrop = this.querySelector('.slide-out-drawer__backdrop');
    this.closeButton = this.querySelector('.slide-out-drawer__close');
  }

  hasElements() {
    if (!this.container || !this.backdrop || !this.closeButton) {
      console.error('Slide-out drawer: Required elements not found', {
        container: !!this.container,
        backdrop: !!this.backdrop,
        closeButton: !!this.closeButton
      });
      return false;
    }
    return true;
  }

  setVariables() {
    this.isOpen = this.classList.contains('open');
    this.identifier = this.dataset.identifier || this.id;
    this.fullIdentifier = this.id;
  }

  setEventListeners() {
    this.closeButton.addEventListener('click', this.close.bind(this));
    this.backdrop.addEventListener('click', this.close.bind(this));
    this.escapeListener = (e) => {
      if (e.key === 'Escape') {
        this.close();
      }
    };
    document.addEventListener('keydown', this.escapeListener);
    this.addEventListener('click', (e) => e.stopPropagation());
  }

  disconnectedCallback() {
    this.removeEventListeners();
    this.isInitialized = false;
  }

  removeEventListeners() {
    document.removeEventListener('keydown', this.escapeListener);
  }

  open() {
    if (!this.isInitialized || this.isOpen) return;

    this.focusedElementBeforeOpen = document.activeElement;
    this.scrollPosition = window.pageYOffset;
    scrollLock.enableBodyScrollLock(this.scrollPosition);

    requestAnimationFrame(() => {
      this.classList.add('open');
      this.setAttribute('aria-hidden', 'false');
      this.isOpen = true;
      trapFocus(this.container);
      const firstFocusableElement = getFocusableElements(this.container)[0];
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
      this.dispatchDrawerEvent('open');
      this.handleDrawerOpen();
    });
  }

  close() {
    if (!this.isInitialized || !this.isOpen) return;

    scrollLock.disableBodyScrollLock();
    this.classList.add('closing');
    this.classList.remove('open');

    const handleAnimationEnd = () => {
      this.classList.remove('closing');
      this.setAttribute('aria-hidden', 'true');
      this.isOpen = false;
      removeTrapFocus();
      if (this.focusedElementBeforeOpen) {
        this.focusedElementBeforeOpen.focus();
      }
      this.dispatchDrawerEvent('close');
      this.handleDrawerClose();
      this.removeEventListener('animationend', handleAnimationEnd);
    };

    this.addEventListener('animationend', handleAnimationEnd);
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  isDrawerOpen() {
    return this.isOpen;
  }

  getScrollPosition() {
    return this.scrollPosition;
  }

  dispatchDrawerEvent(action) {
    const event = new CustomEvent(`drawer:${action}`, {
      bubbles: true,
      detail: {
        identifier: this.identifier,
        scrollPosition: this.scrollPosition
      }
    });
    this.dispatchEvent(event);
  }

  handleDrawerOpen() {
    if (typeof window.handleDrawerOpen === 'function') {
      window.handleDrawerOpen(this.identifier, this.scrollPosition);
    }
  }

  handleDrawerClose() {
    if (typeof window.handleDrawerClose === 'function') {
      window.handleDrawerClose(this.identifier);
    }
  }
}

customElements.define('slide-out-drawer', SlideOutDrawer);

// Slide out drawer opener
class SlideOutDrawerOpener extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.isInitialized) return;
    this.isInitialized = true;
    // grab the internal button used for click event
    this.button = this.querySelector('button');
    // if we don't have a button, do not attach the event listener
    if (!this.button) {
      console.error('Slide-out drawer opener: Button not found');
      return;
    }
    // grab the drawer identifier related to this opener
    this.drawerId = this.dataset.drawer || "slide-out-drawer-null";
    this.drawer = document.getElementById(this.drawerId);
    if (this.drawer && this.drawer instanceof SlideOutDrawer) {
      this.drawer.addEventListener('slide-out-drawer:close', () => {
        this.button.setAttribute('aria-expanded', 'false');
      });
      this.drawer.addEventListener('slide-out-drawer:open', () => {
        this.button.setAttribute('aria-expanded', 'true');
      });
    } else {
      console.error(`Slide-out drawer opener: Drawer with id "${this.drawerId}" not found or is not a SlideOutDrawer instance`);
    }
    // attach click event to the internal button
    this.button.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    this.debounce(() => {
      if (this.drawer && this.drawer instanceof SlideOutDrawer) {
        this.drawer.open();
      } else {
        console.error(`Slide-out drawer opener: Drawer with id "${this.drawerId}" not found or is not a SlideOutDrawer instance`);
      }
    }, 250);
  }

  // Debounce function
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}
customElements.define('slide-out-drawer-opener', SlideOutDrawerOpener);

// fork slide-out-drawer components for the cart-drawer
class CartDrawer extends SlideOutDrawer {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.setCartEventListeners();
  }

  setCartEventListeners() {
    const clearCartLink = this.querySelector('.cart-drawer__clear');
    if (clearCartLink) {
      clearCartLink.addEventListener('click', this.handleClearCart.bind(this));
    }
  }

  handleClearCart(event) {
    event.preventDefault();
    this.clear();
  }

  async clear() {
    try {
      const response = await fetch(`${window.routes.cart_clear_url}.js`, { method: 'POST' });
      if (response.ok) {
        await this.refresh();
      } else {
        console.error('Failed to clear cart');
      }
    } catch (error) {
      console.error('Error clearing cart:', error);
    }
  }

  async refresh() {
    try {
      const response = await fetch('/?section_id=cart-drawer');
      if (response.ok) {
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartDrawerContent = doc.querySelector('.slide-out-drawer__inner');

        if (newCartDrawerContent) {
          const currentCartDrawer = this.querySelector('.slide-out-drawer__inner');
          if (currentCartDrawer) {
            currentCartDrawer.innerHTML = newCartDrawerContent.innerHTML;
            super.initializeDrawer();
            this.setCartEventListeners(); // Rebind events for new elements
          }
        }

        this.dispatchEvent(new CustomEvent('cart:refreshed', { bubbles: true }));
      } else {
        console.error('Failed to fetch updated cart drawer content');
      }
    } catch (error) {
      console.error('Error refreshing cart drawer:', error);
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerOpener extends SlideOutDrawerOpener {
  constructor() {
    super();
  }

  connectedCallback() {
    // grab the internal link used for click event
    this.link = this.querySelector('a');
    // if we don't have a link, do not attach the event listener
    if (!this.link) {
      console.error('cart drawer opener: open link not found');
      return;
    }
    // grab the drawer identifier related to this opener
    this.drawerId = this.dataset.drawer || "cart-drawer";
    this.drawer = document.getElementById(this.drawerId);
    if (this.drawer && this.drawer instanceof CartDrawer) {
       // attach click event to the internal button
      this.link.addEventListener('click', this.handleClick.bind(this));
    } else {
      console.error(`cart drawer opener: Drawer with id "${this.drawerId}" not found or is not a CartDrawer instance`);
    }
  }

  handleClick(event) {
    event.preventDefault();
    if (this.drawer && this.drawer instanceof CartDrawer) {
      this.drawer.open();
    } else {
      console.error(`cart drawer opener: Drawer with id "${this.drawerId}" not found or is not a CartDrawer instance`);
    }
  };
}
customElements.define('cart-drawer-opener', CartDrawerOpener);
class CartItem extends HTMLElement {
  constructor() {
    super();
    this.drawer = null;
    this.itemData = null;
    this.quantityInput = null;
    this.quantityPlus = null;
    this.quantityMinus = null;
    this.cartError = null;
    this.debouncedUpdateQuantity = this.debounce(this.updateQuantity.bind(this), 250);
  }

  connectedCallback() {
    this.drawer = this.closest('cart-drawer');
    this.itemData = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    this.quantityInput = this.querySelector('.cart-drawer__cart-item-quantity-value');
    this.quantityPlus = this.querySelector('.cart-drawer__cart-item-quantity-plus');
    this.quantityMinus = this.querySelector('.cart-drawer__cart-item-quantity-minus');
    this.cartError = this.querySelector('.cart-drawer__cart-item-cart-error');
    this.setEventListeners();
  }

  setEventListeners() {
    this.quantityInput.addEventListener('change', this.handleChange.bind(this));
    this.quantityPlus.addEventListener('click', this.handleIncrease.bind(this));
    this.quantityMinus.addEventListener('click', this.handleDecrease.bind(this));
  }

  handleIncrease(event) {
    event.preventDefault();
    const newQuantity = parseInt(this.quantityInput.value) + 1;
    this.debouncedUpdateQuantity(newQuantity);
  }

  handleDecrease(event) {
    event.preventDefault();
    const newQuantity = parseInt(this.quantityInput.value) - 1;
    if (newQuantity >= 0) {
      this.debouncedUpdateQuantity(newQuantity);
    }
  }

  handleChange(event) {
    const newQuantity = parseInt(event.target.value);
    if (!isNaN(newQuantity) && newQuantity >= 0) {
      this.debouncedUpdateQuantity(newQuantity);
    } else {
      this.showError('Please enter a valid quantity.');
    }
  }

  remove() {
    this.debouncedUpdateQuantity(0);
  }

  getData() {
    return this.itemData;
  }

  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  async updateQuantity(newQuantity) {
    try {
      const response = await fetch(`${window.routes.cart_change_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: this.itemData.key,
          quantity: newQuantity
        })
      });

      const cartData = await response.json();
      if (!response.ok) {
        throw new Error(cartData.message || 'An error occurred while updating the cart.');
      }

      // Check if the quantity was actually updated
      const updatedItem = cartData.items.find(item => item.key === this.itemData.key);
      if (updatedItem && updatedItem.quantity !== newQuantity) {
        this.showError('The requested quantity is not available.');
        this.quantityInput.value = updatedItem.quantity;
      } else {
        this.clearError();
        this.quantityInput.value = newQuantity;
      }

      // Refresh the cart drawer
      if (this.drawer && typeof this.drawer.refresh === 'function') {
        await this.drawer.refresh();
      }
    } catch (error) {
      console.error('Error updating cart:', error);
      this.showError(error.message || 'There was an error updating your cart. Please try again.');
    }
  }

  showError(message) {
    this.cartError.textContent = message;
  }

  clearError() {
    this.cartError.textContent = '';
  }
}

customElements.define('cart-item', CartItem);

/**
 *
 * Originally based on code from the Shopify Dawn theme
 * Shopify documentation: https://shopify.dev/docs/storefronts/themes/architecture/sections/integrate-sections-with-the-theme-editor
 * When users customize sections through the theme editor, the HTML of those sections is dynamically added, removed, or re-rendered directly onto the existing DOM, without reloading the entire page.
 * However, any associated JavaScript that runs when the page loads won't run again.
 * Additionally, you must make sure that when a section or block is selected, that section or block becomes, and remains, visible while it’s selected.
 * For example, a slideshow section should scroll into view when the section is selected, slide to a selected block (slide), and pause while that block is selected."
 *
 */
class ShopifyThemeEditorController {
  constructor() {
    this.setEventListeners();
  }

  setEventListeners = () => {
    // blockId represents the block ID
    // sectionId represents the section ID
    // load indicates whether the event is being triggered by a section re-render, or a user selection. The value of load is true or false

    // trigger: A section has been added or re-rendered.
    // expected action: Re-execute any JavaScript needed for the section to work and display properly, as if the page had just been loaded.
    // target: section
    // detail: {sectionId}
    document.addEventListener('shopify:section:load', () => {
      this.handleSectionLoad(event);
    });

    // trigger: A section has been deleted or is being re-rendered
    // expected action: Clean up any event listeners, variables, etc., so that nothing breaks when the page is interacted with and no memory leaks occur.
    // target: section
    // detail: {sectionId}
    document.addEventListener('shopify:section:unload', () => {
      this.handleSectionUnload(event);
    });

    // trigger: The user has selected the section in the sidebar.
    // expected action: The theme editor automatically scrolls to the section, so make sure the section is in view, and stays in view, while selected.
    // target: section
    // detail: {sectionId,load}
    document.addEventListener('shopify:section:select', (event) => {
      this.handleSectionSelect(event);
    });

    // trigger: The user has deselected the section in the sidebar.
    // target: section
    // detail: {sectionId}
    document.addEventListener('shopify:section:deselect', (event) => {
      this.handleSectionDeselect(event);
    });

    // trigger: User has selected the block in the sidebar.
    // expected action: The theme editor automatically scrolls to the section, so make sure the block is in view, and stays in view, while selected.
    // target: block
    // detail: {blockId,sectionId,load}
    document.addEventListener('shopify:block:select', (event) => {
      this.handleBlockSelect(event);
    });

    // trigger: The user has deselected the block in the sidebar.
    // target: block
    // detail: {blockId,sectionId}
    document.addEventListener('shopify:block:deselect', (event) => {
      this.handleBlockDeelect(event);
    });
  }

  // Event Handling Functions

  handleSectionLoad = (event) => {
    // console.log(`handleSectionLoad`, event);
  }

  handleSectionUnload = (event) => {
    // console.log(`handleSectionUnload`, event);
  }

  handleSectionSelect = (event) => {
    // console.log(`handleSectionSelect`, event);
    const sectionTriggersDrawer = event.target.classList.contains('theme-editor-open-drawer');
    if(sectionTriggersDrawer){
      const drawer = event.target.querySelector('.slide-out-drawer');
      drawer.open();
      return;
    }
  }

  handleSectionDeselect = (event) => {
    // console.log(`handleSectionDeselect`, event);
    const sectionTriggersDrawer = event.target.classList.contains('theme-editor-open-drawer');
    if(sectionTriggersDrawer){
      const drawer = event.target.querySelector('.slide-out-drawer');
      drawer.close();
      this.closeSlideOutDrawer(drawer);
      return;
    }
  }

  handleBlockSelect = (event) => {
    // console.log(`handleBlockSelect`, event);
  }

  handleBlockDeelect = (event) => {
    // console.log(`handleBlockDeelect`, event);
  }

}

window.ShopifyThemeEditorController = window.ShopifyThemeEditorController || new ShopifyThemeEditorController();


(function ($) {
  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Main Script
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/

  $(function () {
    /* ----------------------------------------------------------------
    Initializations
    -----------------------------------------------------------------*/
    // Initiate Lazy Loading
    window.rehash_lazyLoad = new LazyLoad({
      elements_selector: ".lazy",
      class_loading: "lazyloading",
      class_loaded: "lazyloaded",
      callback_error: function (e) {
        console.log(e);
      },
    });

    // Re-initialize Lazy Loading on theme editor change
    document.addEventListener("shopify:section:load", function (event) {
      window.rehash_lazyLoad = new LazyLoad({
        elements_selector: ".lazy",
        class_loading: "lazyloading",
        class_loaded: "lazyloaded",
      });
    });


    // Scroll position logic has to be run differently on collection pages
    // so don't run it from here if we're on that page
    if(!$('body').hasClass('collection-template')) {
      saveScrollPosition();

      document.addEventListener("scroll", () => {saveScrollPosition(true)});
    }

    /* ----------------------------------------------------------------
    Navigation v2
    -----------------------------------------------------------------*/

    var prevNavItem;

    const moveNavIndicator = (navItem) => {
      const indicator = document.querySelector("header .indicator");
      let offset =
        navItem.offsetLeft +
        navItem.offsetWidth / 2 -
        indicator.offsetWidth / 2;
      indicator.style.transform = `translateX(${offset}px)`;
    };

    const toggleNav = (isOpen) => {
      isMobile = window.innerWidth < 960;
      document.body.classList.toggle("nav-opened", isOpen);
      if (!isMobile) return;
    };

    const updateNavState = (navItem) => {
      navItem.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        //update active nav item and indicator
        if (prevNavItem) prevNavItem.classList.remove("active");
        navItem.classList.add("active");
        moveNavIndicator(navItem);

        //activate category within nav
        const currentCategory = document.querySelector(
          ".navigation__category.active"
        );
        const newCategory = document.querySelector(
          `.navigation__category[data-category='${navItem.dataset.section}']`
        );
        if (currentCategory != newCategory) {
          //collapse all accordians when switching categories
          document.querySelectorAll(".has-children.opened").forEach((x) => {
            x.classList.remove("opened");
          });
          document
            .querySelectorAll(".navigation__list-item-toggle.opened")
            .forEach((x) => {
              x.classList.remove("opened");
            });
          currentCategory.classList.remove("active");
          newCategory.classList.add("active");
        }

        //toggle nav slide out
        const isCurrentCategory = prevNavItem == navItem;
        const isNavOpen = document.body.classList.contains("nav-opened");
        //document.body.classList.toggle('nav-opened', );
        toggleNav(!isCurrentCategory || !isNavOpen);
        prevNavItem = navItem;
      });
    };

    function toggleScrolledBodyClass(forcedScrollPosition = null) {
      let heightPromo = $('#shopify-section-announcement-bar').height();
      let height = heightPromo ? heightPromo : 0;
      $(".wrapper").css("padding-top", height + "px");

      let currentScrollPosition;
      if (forcedScrollPosition !== null) {
        currentScrollPosition = forcedScrollPosition;
      } else {
        currentScrollPosition = window.pageYOffset;
      }

      let shouldBeScrolled = currentScrollPosition > height;
      $("body").toggleClass("scrolled", shouldBeScrolled);
      document.documentElement.style.setProperty("--header-top", `${height}px`);
      document.documentElement.style.setProperty("--header-height", `${$('header').outerHeight()}px`);
    }

    function toggleScrolledBodyClassPages() {
      let heightPromo = $('#shopify-section-announcement-bar').height()
      let height = heightPromo ? heightPromo : 0;
      $(".wrapper").css("padding-top", height+"px")
      $("body").toggleClass("header-top-position", $(window).scrollTop() < height);
      document.documentElement.style.setProperty(
        "--header-top",
        `${height}px`
      );
    }

    // Global functions to handle drawer events
    window.handleDrawerOpen = function(identifier, scrollPosition) {
      // console.log(`Drawer ${identifier} opened at scroll position ${scrollPosition}`);
      toggleScrolledBodyClass(scrollPosition);
    };

    window.handleDrawerClose = function(identifier) {
      // console.log(`Drawer ${identifier} closed`);
      toggleScrolledBodyClass();
    };

    // Event listeners for drawer events
    document.addEventListener('drawer:open', (event) => {
      toggleScrolledBodyClass(event.detail.scrollPosition);
    });

    document.addEventListener('drawer:close', () => {
      toggleScrolledBodyClass();
    });

    // Initialize and set up scroll handlers
    $(document).ready(function() {
      if ($("body.index-template").length) {
        toggleScrolledBodyClass();
        $(window).on('scroll', () => {
          let anyDrawerOpen = document.querySelector('.slide-out-drawer.open');
          if (!anyDrawerOpen) {
            toggleScrolledBodyClass();
          }
        });
      } else {
        toggleScrolledBodyClassPages();
        $(document).on("scroll", function () {
          toggleScrolledBodyClassPages();
        });
      }
    });

    function toggleDropdownsOpen() {
      $('[data-open-mobile]').each(function(_, element) {
        element.classList.add('-act')
        element.nextElementSibling.style.display = 'block'
      })
    }

    $('.rwd-menu-child__slide').on("click", function (e) {
      $(this).next().toggleClass('d-none');
      toggleDropdownsOpen()
    });

    $('.rwd-menu__back').on("click", function (e) {
      $(this).parents('.rwd-menu-slide').toggleClass('d-none')
    });

    $('.rwd-menu-childs__slide').on("click", function (e) {
      $(this).toggleClass('-act').next().slideToggle()
    });

    $('.rwd-init').on("click", function (e) {
      $('.rwd-menu').toggleClass('d-none')
      $('html').css({ 'height': '100vh', 'overflow': 'hidden' })
      $('body').addClass('scroll-fix')
    });

    $('.rwd-menu__close').on("click", function (e) {
      $('html').css({ 'height': '', 'overflow': '' })
      $('body').removeClass('scroll-fix')
      $('.rwd-menu').toggleClass('d-none')
      $('.rwd-menu-childs__slide').removeClass('-act').next().hide()
      $('.rwd-menu-slide').addClass('d-none')
    });

    $(".header-search__action").on("click", function (e) {
      e.preventDefault();
      $(".header__search")
        .toggleClass("header__search--open")
        .find("input")
        .focus();
      $("body").toggleClass("search--open");
    });

    $(".header__search-close").on("click", function (e) {
      e.preventDefault();
      $(".header__search")
        .toggleClass("header__search--open")
        .find("input")
        .blur();
      $("body").toggleClass("search--open");
    });

    /* ----------------------------------------------------------------
    jQuery toggles
    -----------------------------------------------------------------*/
    //Filters toggle

    $('.filter-toggle').on("click", function () {
      let eventFired = 0;

      if ($(window).width() < 960) {
        $('.boost-pfs-filter-option-content').addClass('toggled')
        $('.boost-pfs-filter-button.boost-pfs-filter-option-title-heading').attr('aria-expanded','false')
        $('.boost-pfs-filter-option').addClass('boost-pfs-filter-option-collapsed')
      }
      else {
        eventFired = 1;
      }

      $(window).resize(function () {
        if (!eventFired) {
          if ($(window).width() < 960) {
            $('.boost-pfs-filter-option-content').addClass('toggled')
            $('.boost-pfs-filter-button.boost-pfs-filter-option-title-heading').attr('aria-expanded','false')
            $('.boost-pfs-filter-option').addClass('boost-pfs-filter-option-collapsed')
          }
          else {
          }
        }
      });

      $(this).toggleClass('filter-toggle-act')
      $('.boost-pfs-filter-tree').toggleClass('d-none')

    });


    //Login Page - forgot password toggle
    $("#forgot-password").on("click", function () {
      $("#recover-password-form").show();
      $("#customer-login-form").hide();
    });

    $("#forgot-password-cancel").on("click", function () {
      $("#recover-password-form").hide();
      $("#customer-login-form").show();
    });

    // handles opening/closing of the custom dropdown UI
    $(document).on(
      "click",
      ".dropdown:not(.dropdown--display-only) .dropdown__label",
      function (e) {
        var _this = $(this);

        _this.toggleClass("dropdown__label--selected");
        _this.next().slideToggle(200);
      }
    );

    // handles clicking an item inside the list
    $(document).on(
      "click",
      ".dropdown:not(.dropdown--display-only) .dropdown__list-item a",
      function (e) {
        var _this = $(this),
          list_item = $(this).parent(),
          container = _this.parents(".dropdown"),
          label = container.find(".dropdown__label"),
          isSort = container.hasClass("dropdown--sort");

        if (_this.hasClass("disabled")) {
          return false;
        }

        if (_this.attr("href") === "#") {
          e.preventDefault();
        } else {
          return;
        }

        if (isSort && window.innerWidth < 960) {
          $("#sort-by-select")
            .val(_this.parent().data("value"))
            .trigger("change");
          container.find(".sorting-header__close").trigger("click");
          return;
        }

        container
          .find(".dropdown__list-item")
          .removeClass("dropdown__list-item--selected");
        list_item.addClass("dropdown__list-item--selected");
        container
          .find(".dropdown__select")
          .val(list_item.data("value"))
          .trigger("change");
        label.trigger("click");

        if (window.innerWidth > 960 || !isSort) {
          label.find("span").text(_this.text());
          if (list_item.hasClass("dropdown__list-item--unavailable")) {
            label.addClass("dropdown__label--unavailable");
          } else {
            label.removeClass("dropdown__label--unavailable");
          }
        }
      }
    );


    $(document).on("click", ".swatch__list-item a", function (e) {
      var _this = $(this),
        list_item = $(this).parent(),
        container = _this.parents(".product-swatch")

      if (_this.hasClass("disabled")) {
        return false;
      }

      if (_this.attr("href") === "#") {
        e.preventDefault();
      } else {
        return;
      }

      container
        .find(".swatch__list-item")
        .removeClass("dropdown__list-item--selected");
      list_item.addClass("dropdown__list-item--selected");
      container
        .find(".dropdown__select")
        .val(list_item.data("value"))
        .trigger("change");

    });

    $(document).on("click", function (e) {
      var container = $(".dropdown");

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container
          .find(".dropdown__label")
          .removeClass("dropdown__label--selected");
        container.find(".dropdown__list").slideUp(200);
      }
    });

    if ($("body.page-stores-template").length) {
      $(function () {
        var adjustStoreHeights = (function () {
          var leftColumnHeight = 0,
            rightColumnHeight = 0,
            $stores = $(".stores .store-group");
          for (var i = 0; i < $stores.length; i++) {
            if (leftColumnHeight > rightColumnHeight) {
              rightColumnHeight += $stores
                .eq(i)
                .addClass("store-group--right")
                .outerHeight(true);
            } else {
              leftColumnHeight += $stores.eq(i).outerHeight(true);
            }
          }
          return $stores;
        })();

        document.addEventListener("shopify:section:load", function (event) {
          adjustStoreHeights();
        });
      });
    }

    if ($("body.page-faqs-template").length) {
      $(document).on("click", ".faq__title", function (e) {
        $(this).toggleClass("faq__title--visible").next().slideToggle(250);
      });
    }

    function shuffleArray(array) {
      for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return array;
    }

    //Details Toggle
    const detailsElements = document.querySelectorAll("details");

    function handleClickOnDetails() {
      // close all details
      let detailsOpened = document.querySelectorAll("details[open]");

      for (const item of detailsOpened) {
        // keep open only details clicked
        if (this != item) {
          item.removeAttribute("open");
        }
      }
    }

    detailsElements.forEach(function (item) {
      item.addEventListener("click", handleClickOnDetails);
    });

    // Recommended Product Feature
    function displayRecommendedProducts(products) {
      products = shuffleArray(products);
      products.forEach(function (product, index) {
        if (index >= 12) {
          return false;
        }
        var product_loop_template = $("#related-product__template").html();
        var compiled_html = _.template(product_loop_template, product);
        $(".section--related-products .products").append(
          compiled_html({ product: product })
        );
        if (REBASE && REBASE.lists) {
          REBASE.lists.updateActiveProductVariant({
            product_id: product.id,
            variant_id: product.variants[0].id,
          });
        }
      });
      $(document).trigger("displayRecommendedProductsComplete");
    }

    function getRecommendedProducts(id) {
      $.getJSON(
        "/recommendations/products.json?product_id=" + id + "&limit=12",
        function (resp) {
          if (resp.products && resp.products.length) {
            displayRecommendedProducts(resp.products);
          } else {
            $(".section--related-products").hide();
          }
        }
      );
    }

    if (
      $("body").hasClass("product-template") &&
      !$("body").hasClass("product-sustainability-template")
    ) {
      var product_data_recommended = JSON.parse(
        document.getElementById("product__json").innerHTML
      );
      if (
        typeof rehash_related_products !== "undefined" &&
        rehash_related_products.length
      ) {
        displayRecommendedProducts(rehash_related_products);
      } else {
        getRecommendedProducts(product_data_recommended.id);
      }
    }

    // window.addEventListener("klaviyoForms", function(e) {
    //   if (e.detail.type == 'open') {
    //     setTimeout(function() {
    //       console.log(document.querySelector('.klaviyo-form label div'));
    //       var text = document.querySelector('.klaviyo-form label div').innerHTML;
    //       var link = '<a href="#">Privacy Policy</a>';
    //       document.querySelector('.klaviyo-form label div').innerHTML = text.replace(/({policy_link})/g, link);
    //     }, 0)
    //  }
    // });

    // var video_hero_trigger = document.querySelector(
    //   "main .shopify-section:first-child .video-trigger"
    // );
    // if (video_hero_trigger) {
    //   video_hero_trigger.click();
    // }

    //store affiliate id in session var
    var affiliate_qs_key = "eid";
    var urlParams = new URLSearchParams(window.location.search);
    var affiliateId = urlParams.get(affiliate_qs_key);
    if (affiliateId && !sessionStorage.getItem("affiliate_id")) {
      sessionStorage.setItem("affiliate_id", affiliateId);
    }
  });
})(jQuery);
